import React, { Component, Fragment } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Col, Row, Label, Nav, NavItem, NavLink, Card, Button } from 'reactstrap'
import Loader from "../../../Material/Loader"
import "react-awesome-lightbox/build/style.css"
import DatetimeRenderer from "../../../Material/DatetimeRenderer"
import gql from 'graphql-tag'
import DocumentModalNew from "../../../Material/DocumentModal/DocumentModalNew"
import CarIssueModal from "../../../Maintenance/CarIssueModal"
import { cleanDocumentUrl } from "../../../Material/DocumentModal/DocumentsListNew"
import Table from "reactstrap/lib/Table"
import ViewPDFDocument from "../../../Material/DocumentModal/ViewPDFDocument"
import withApolloClient from '../../../withApolloClient'
import { GAS_LABELS } from "../../../Constants"
import toTitleCase from "../../../Functions/toTitleCase"
import RenderIncidentDetail from "../../../Incidents/RenderIncidentDetail"
import AddNewIncidentModal from "../../../Incidents/IncidentModals/AddNewIncidentModal"

const CarIssuesSeverityLevelQuery = gql`{
  carIssueSeverityLevels: __type(name: "CarsCarIssuesSeverityChoices") {
    states: enumValues {
      name
      description
    }
  }
}
`

// The report is a PDF rendered on request, so it is asked for only when its tab is opened rather than on
// every inspection the user clicks through.
const CarConditionInspectionReportQuery = gql`query carConditionInspectionReport($id: ID!){
    carCondition(carConditionId:$id){
        id
        inspectionReportPdf
    }
}`

const CarConditionDetailQuery = gql`query carCondition($id: ID!, $loadIncidentSet: Boolean!){
    carCondition(carConditionId:$id){
        id
        pk
        dateAdded
        dateModified
        formType
        sourceDisplay
        gas
        mileage
        cancellationReason
        carissuesSet(isIncidentDamage:false){
          edges {
            node {
              id
              pk
              dateAdded
              dateModified
              dateClosed
              status
              issueDesc
              reportedBy
              notes
              externalId
              severity
              projectedCost
              needsReview
              canPickup
              pictures {
                edges {
                  node {
                    id
                    dateAdded
                    pictureUrl
                    pictureType
                    description
                  }
                }
              }
              car{
                id
                pk
              }
              issueCategory {
                id
                name: category
              }
              vendor {
                id
                name
              }
            }
          }
        }
        user{
          id
          username
          firstName
          lastName
        }
        incidentSet @include(if: $loadIncidentSet) {
            edges {
                node {
                    id
                    pk
                    dateAdded
                    title
                }
            }
        }
        carpicturesSet {
          edges {
            node {
              id
              dateAdded
              pictureUrl
              pictureType
              description
            }
          }
        }
        car {
          id
          branch {
            id
          }
        }

    }
}`

class CarInspectionDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            error: null,
            loading: false,
            successMessage: "",
            picturesSetSubsection: "walkaroundPictures",
            carInspectionSubsection: "inspectionDetails",
            activeIncidentId: this.props.carCondition && this.props.carCondition.incidentSet && this.props.carCondition.incidentSet.edges && this.props.carCondition.incidentSet.edges.length > 0 ? this.props.carCondition.incidentSet.edges[0].node.id : "",
            inspectionReportUrl: null,
            inspectionReportFor: null,
            inspectionReportLoading: false,
            inspectionReportError: null
        }
    }

    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "", error: "" })
        } else {
            this.setState({ openModal: modalName, error: "" })
        }
    }

    toggleSectionNav = (sectionName, value) => {
        this.setState({ [sectionName]: value })
        if (sectionName === "picturesSetSubsection" && value === "inspectionReport") this.loadInspectionReport()
    }

    loadInspectionReport = () => {
        const carConditionId = this.props.carCondition && this.props.carCondition.id
        if (!carConditionId || this.state.inspectionReportFor === carConditionId || this.state.inspectionReportLoading) return

        this.setState({ inspectionReportLoading: true, inspectionReportError: null })
        this.props.apolloClient.query({
            query: CarConditionInspectionReportQuery,
            variables: { id: carConditionId },
        }).then(({ data }) => {
            this.revokePdfUrl()
            this.setState({ inspectionReportUrl: null, inspectionReportFor: carConditionId, inspectionReportLoading: false })
            this.preparePdfUrl(data && data.carCondition && data.carCondition.inspectionReportPdf)
        }).catch(() => {
            this.setState({ inspectionReportLoading: false, inspectionReportError: "The inspection report could not be loaded." })
        })
    }

    viewPictures = (carPictures, index = 0) => {
        let pictures = carPictures.map(picture => ({ documentUrl: cleanDocumentUrl(picture.node.pictureUrl), id: picture.node.id, name: picture.node.pictureType, description: picture.node.description, dateAdded: picture.node.dateAdded }))
        this.setState({ carPictures: pictures, selectedImage: pictures[index] })
    }

    next = () => {
        const carPictures = this.state.carPictures
        const currentIndex = carPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === carPictures.length - 1) return
        this.setState({ selectedImage: carPictures[currentIndex + 1] })
    }

    prev = () => {
        const carPictures = this.state.carPictures
        const currentIndex = carPictures.findIndex(item => item.id === this.state.selectedImage.id)
        if (currentIndex === 0) return
        this.setState({ selectedImage: carPictures[currentIndex - 1] })
    }

    handleClose = () => {
        this.setState({
            loading: false,
            error: "",
            successMessage: "",
            openModal: "",
        })
    }

    componentDidUpdate(prevProps, prevState) {
        const { carCondition, activeTab, location } = this.props
        const carConditionChanged = prevProps.carCondition !== carCondition
        const carIncidents = carCondition && carCondition.incidentSet && carCondition.incidentSet.edges && carCondition.incidentSet.edges.length > 0
        if (this.props.viewType !== "incidents" && carIncidents &&
            ((this.state.carInspectionSubsection !== prevState.carInspectionSubsection && this.state.carInspectionSubsection === "incidentDetail") ||
                (activeTab !== prevProps.activeTab && activeTab === "inspections") ||
                carConditionChanged
            )
        ) {
            const defaultIncident = carCondition && carCondition.incidentSet && carCondition.incidentSet.edges && carCondition.incidentSet.edges.length > 0 && carCondition.incidentSet.edges[0].node
            const queryParams = new URLSearchParams(location.search)
            const existingIncidentId = queryParams.get("incidentId")

            if (existingIncidentId) {
                const validIncident = carCondition.incidentSet.edges.find(
                    inspection => inspection.node.id === existingIncidentId
                )

                const newActiveIncidentId = validIncident ? validIncident.node.id : defaultIncident.id
                this.setState({ activeIncidentId: newActiveIncidentId })

                if (!validIncident) {
                    this.props.setUrlParams(defaultIncident.id)
                }
            } else {
                this.setState({ activeIncidentId: defaultIncident.id })
                this.props.setUrlParams(defaultIncident.id)
            }
        }
        if (prevProps.carCondition?.id !== this.props.carCondition?.id) {
            this.revokePdfUrl()
            this.setState(
                { inspectionReportUrl: null, inspectionReportFor: null, inspectionReportError: null },
                () => this.state.picturesSetSubsection === "inspectionReport" && this.loadInspectionReport()
            )
        }
    }

    componentDidMount() {
        if (this.props.viewType !== "incidents" && this.props.location && this.props.location.search && this.props.location.search.includes("incidentId")) {
            this.setState({ carInspectionSubsection: "incidentDetail" })
        }
    }

    componentWillUnmount() {
        this.revokePdfUrl()
    }
    revokePdfUrl = () => {
        if (this.state.inspectionReportUrl) URL.revokeObjectURL(this.state.inspectionReportUrl)
    };

    preparePdfUrl = (val) => {
        if (!val) return
        // If already a data URL, convert to Blob; else treat as raw base64
        const dataUrlPrefix = 'data:application/pdf;base64,'
        let base64 = val.startsWith('data:') ? val.split(',')[1] : val
        base64 = base64.replace(/\s+/g, '') // strip whitespace/newlines
        const byteChars = atob(base64)
        const byteNumbers = new Array(byteChars.length)
        for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i)
        const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)
        this.setState({ inspectionReportUrl: url })
    };

    setIncidentId = (id) => {
        this.props.setUrlParams(id)
        this.setState({ activeIncidentId: id })
    }

    render() {
        return (
            <>
                {this.state.selectedImage &&
                    <DocumentModalNew
                        document={this.state.selectedImage}
                        handleClose={() => this.setState({ selectedImage: null })}
                        next={this.next}
                        prev={this.prev}
                        objectType={"car"}
                        isPicture={true}
                        refetch={this.props.refetch}
                        currentUser={this.props.currentUser}
                    />
                }
                {this.props.carConditionLoading ? <Loader /> : <>
                    <div className="inspection-detail">
                        <Nav tabs className="d-flex w-100">
                            <NavItem className={this.state.tab === "inspectionDetails" ? "active" : "inactive"}>
                                <NavLink className={this.state.carInspectionSubsection === "inspectionDetails" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("carInspectionSubsection", "inspectionDetails")}>
                                    INSPECTION #{this.props.carCondition.pk}
                                </NavLink>
                            </NavItem>
                            {this.props.viewType !== "incidents" &&
                                <NavItem className={this.state.tab === "incidentDetail" ? "active" : "inactive"}>
                                    <NavLink className={this.state.carInspectionSubsection === "incidentDetail" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("carInspectionSubsection", "incidentDetail")}>
                                        REPORTED INCIDENTS
                                    </NavLink>
                                </NavItem>
                            }
                            <NavItem className={this.state.tab === "otherIssues" ? "active" : "inactive"}>
                                <NavLink className={this.state.carInspectionSubsection === "otherIssues" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("carInspectionSubsection", "otherIssues")}>
                                    OTHER ISSUES
                                </NavLink>
                            </NavItem>
                            <div className="ml-auto">
                                {this.state.carInspectionSubsection === "incidentDetail" && this.props.carCondition?.formType?.toUpperCase() === "RETURN" &&
                                    <div>
                                        <Button id={"addNewIncident"} className="primary" onClick={() => this.setState({ openModal: "addNewIncident" })}>Add New Incident</Button>
                                    </div>
                                }
                                {this.state.openModal === "addNewIncident" && this.state.carInspectionSubsection === "incidentDetail" &&
                                    <AddNewIncidentModal
                                        isOpen={this.state.openModal === "addNewIncident"}
                                        toggle={() => this.toggleModal("addNewIncident")}
                                        refetchQuery={this.props.refetchQuery}
                                        carConditionId={this.props.id}
                                        branchId={this.props.carCondition?.car?.branch?.id}
                                    />
                                }
                            </div>
                        </Nav>
                        <div className="info-container" style={{ margin: "0px", borderTopLeftRadius: "0px" }}>
                            <Row>
                                <Col>
                                    {this.props.carCondition ?
                                        this.state.carInspectionSubsection === "inspectionDetails" ?
                                            <div>
                                                <Row>
                                                    <Col xs={4}>
                                                        <Label>Date Added</Label>
                                                        <p>{this.props.carCondition.dateAdded ? <DatetimeRenderer datetime={this.props.carCondition.dateAdded} placement="right" /> : "--"}</p>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <Label>Date Modified</Label>
                                                        <p>{this.props.carCondition.dateModified ? <DatetimeRenderer datetime={this.props.carCondition.dateModified} placement="right" /> : "--"}</p>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <Label>Inspection Type</Label>
                                                        <p>
                                                            {this.props.carCondition.formType ? toTitleCase(this.props.carCondition.formType) : "---"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <Label>Source</Label>
                                                        <p className="columnContent">
                                                            {this.props.carCondition.sourceDisplay || "---"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <Label>User</Label>
                                                        <p className="columnContent">
                                                            {this.props.carCondition && this.props.carCondition.user ? this.props.carCondition.user.firstName ? this.props.carCondition.user.firstName + " " + this.props.carCondition.user.lastName : this.props.carCondition.user.username : "---"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <Label>Gas</Label>
                                                        <p className="columnContent">
                                                            {GAS_LABELS[parseInt(this.props.carCondition.gas?.split('_')[1])] || "Unknown"}
                                                        </p>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <Label>Mileage</Label>
                                                        <p className="columnContent">{this.props.carCondition.mileage}</p>
                                                    </Col>
                                                    {this.props.carCondition.cancellationReason &&
                                                        <Col xs={12}>
                                                            <Label>Canceled</Label>
                                                            <p className="columnContent danger">
                                                                <i className="fa fa-ban" aria-hidden="true"></i>&nbsp;
                                                                {this.props.carCondition.cancellationReason}
                                                            </p>
                                                        </Col>
                                                    }
                                                </Row>
                                            </div> :
                                            this.state.carInspectionSubsection === "otherIssues" ?
                                                <Row>
                                                    <Col>
                                                        <Table responsive>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ fontWeight: 500 }}>Date Added</th>
                                                                    <th style={{ fontWeight: 500 }}>Category</th>
                                                                    <th style={{ fontWeight: 500 }}>Status</th>
                                                                    <th style={{ fontWeight: 500 }}>Projected Cost</th>
                                                                    <th style={{ fontWeight: 500 }}>Severity</th>
                                                                    <th style={{ fontWeight: 500 }}>Can Pickup</th>
                                                                    <th style={{ fontWeight: 500 }}>Pictures</th>
                                                                    <th style={{ fontWeight: 500 }}>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.props.carCondition && this.props.carCondition.carissuesSet && this.props.carCondition.carissuesSet.edges && this.props.carCondition.carissuesSet.edges.length > 0 ? this.props.carCondition.carissuesSet.edges.map((issue, i) =>
                                                                    <tr key={i}>
                                                                        <td><small>{issue.node.dateAdded ? <DatetimeRenderer datetime={issue.node.dateAdded} placement="right" /> : "---"}</small></td>
                                                                        <td><small>{issue.node.issueCategory ? issue.node.issueCategory.name : "---"}</small></td>
                                                                        <td><small>{issue.node.status ? issue.node.status : "---"}</small></td>
                                                                        <td><small>{issue.node.projectedCost ? `$${issue.node.projectedCost}` : "---"}</small></td>
                                                                        <td><small>{this.props?.carIssueSeverityLevels?.states.find(item => item.name === issue.node.severity)?.description || '---'}</small></td>
                                                                        <td><small>{issue.node.canPickup ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</small></td>
                                                                        <td>
                                                                            <small>
                                                                                {issue.node.pictures && issue.node.pictures.edges && issue.node.pictures.edges.length > 0 ?
                                                                                    <div onClick={() => this.viewPictures(issue.node.pictures.edges)}>
                                                                                        <i className="fa fa-file-image-o fa-lg" aria-hidden="true"></i>
                                                                                        {issue.node.pictures.edges.length > 1 &&
                                                                                            <a className="bos-custom-link">
                                                                                                {" "}+{issue.node.pictures.edges.length - 1} more
                                                                                            </a>}
                                                                                    </div> :
                                                                                    "No Pictures Found"}
                                                                            </small>
                                                                        </td>
                                                                        <td>
                                                                            <i id={"editCarIssue" + i} className="fa fa-pencil-square-o" aria-hidden="true" onClick={() => this.setState({ openModal: "editCarIssue" + i })}></i>
                                                                            {this.state.openModal === "editCarIssue" + i && <CarIssueModal open={this.state.openModal === "editCarIssue" + i} isUpdate carIssue={issue.node} handleClose={() => this.toggleModal("editCarIssue" + i)} refetchQuery={this.props.refetchQuery} />}
                                                                        </td>
                                                                    </tr>
                                                                ) : <tr><td colSpan={4} style={{ color: "red" }}>No Other Issues Found!</td></tr>
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                                : this.state.carInspectionSubsection === "incidentDetail" ?
                                                    <div>
                                                        <Row>
                                                            <Col xs={2} className="inspections-list" >
                                                                {this.props.loading ? <Loader /> : <>
                                                                    {this.props.carCondition && this.props.carCondition.incidentSet && this.props.carCondition.incidentSet.edges && this.props.carCondition.incidentSet.edges.length > 0 ? this.props.carCondition.incidentSet.edges.map((incident, i) =>
                                                                        <div className={"car-inspection" + (this.state.activeIncidentId === (incident.node.id) ? " active" : "")} onClick={() => this.setIncidentId(incident.node.id)} key={i}>
                                                                            <div className={"sidebar-listing-wrapper-text"}>
                                                                                <p><small>{incident.node.title}</small></p>
                                                                            </div>
                                                                        </div>
                                                                    ) : <div><p className="text-center no-rentals">No Car Condition Found!</p></div>
                                                                    }
                                                                </>}
                                                            </Col>
                                                            <Col xs={10}>
                                                                {this.state.activeIncidentId && this.props.carCondition?.incidentSet?.edges?.length > 0 ?
                                                                    <RenderIncidentDetail id={this.state.activeIncidentId} viewType={"car"} /> :
                                                                    <Row>
                                                                        <Col>
                                                                            <p>No incident found!</p>
                                                                        </Col>
                                                                    </Row>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </div> :
                                                    <>

                                                    </>
                                        : <p style={{ color: "red" }}>No Car Condition Found!</p>
                                    }
                                </Col>
                            </Row>
                        </div>
                        <br />
                        <Nav tabs>
                            <NavItem className={this.state.tab === "walkaroundPictures" ? "active" : "inactive"}>
                                <NavLink className={this.state.picturesSetSubsection === "walkaroundPictures" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("picturesSetSubsection", "walkaroundPictures")}>
                                    Walkaround Pictures
                                </NavLink>
                            </NavItem>
                            <NavItem className={this.state.tab === "otherPictures" ? "active" : "inactive"}>
                                <NavLink className={this.state.picturesSetSubsection === "otherPictures" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("picturesSetSubsection", "otherPictures")}>
                                    Other Pictures
                                </NavLink>
                            </NavItem>
                            <NavItem className={this.state.tab === "inspectionReport" ? "active" : "inactive"}>
                                <NavLink className={this.state.picturesSetSubsection === "inspectionReport" ? "active navItem" : "navItem"} onClick={() => this.toggleSectionNav("picturesSetSubsection", "inspectionReport")}>
                                    Inspection Report
                                </NavLink>
                            </NavItem>
                        </Nav>
                        {
                            this.state.picturesSetSubsection === "walkaroundPictures" ?
                                <div className="info-container" style={{ maxHeight: "500px", overflow: "auto" }}>
                                    <Row>
                                        <Col>
                                            <Fragment>
                                                <div className="DocumentCardContainer">
                                                    {this.props.carCondition && this.props.carCondition.carpicturesSet && this.props.carCondition.carpicturesSet.edges.filter(picture =>
                                                        picture.node.pictureType &&
                                                        picture.node.pictureType.toLowerCase() === "exterior_walkaround"
                                                    ).map((document, index) =>
                                                        <Card className="DocumentCard" key={index}>
                                                            <div className="DocumentCardHeader" onClick={() => this.viewPictures(this.props.carCondition.carpicturesSet.edges.filter(picture =>
                                                                picture.node.pictureType &&
                                                                picture.node.pictureType.toLowerCase() === "exterior_walkaround"
                                                            ), index)}>
                                                                <p className="DocumentCardTitle">
                                                                    <span><i className="fa fa-picture-o" aria-hidden="true"></i></span>&nbsp;&nbsp;
                                                                    <span>{document.node.pictureType} <small>({document.node.description})</small></span>
                                                                </p>
                                                                <p><i className="fa fa-arrows-alt"></i></p>
                                                            </div>
                                                            <div className="DocumentCardPreview">
                                                                {document.node ? (
                                                                    <img className="DocumentCardPreviewEmbed DocViewerImage" src={document.node.pictureUrl} alt="Document" />
                                                                ) : ''}
                                                            </div>
                                                        </Card>
                                                    )}
                                                </div>
                                            </Fragment>
                                        </Col>
                                    </Row>
                                </div> :
                                this.state.picturesSetSubsection === "otherPictures" ?
                                    <div className="info-container" style={{ maxHeight: "500px", overflow: "auto" }}>
                                        <Row>
                                            <Col>
                                                <Fragment>
                                                    <div className="DocumentCardContainer">
                                                        {this.props.carCondition && this.props.carCondition.carpicturesSet && this.props.carCondition.carpicturesSet.edges.filter(picture => picture.node.pictureType && picture.node.pictureType.toLowerCase() !== "exterior_walkaround").map((document, index) =>
                                                            <Card className="DocumentCard" key={index}>
                                                                <div className="DocumentCardHeader" onClick={() => this.viewPictures(this.props.carCondition.carpicturesSet.edges.filter(picture => picture.node.pictureType && picture.node.pictureType.toLowerCase() !== "exterior_walkaround"
                                                                ), index)}>
                                                                    <p className="DocumentCardTitle">
                                                                        <span><i className="fa fa-picture-o" aria-hidden="true"></i></span>&nbsp;&nbsp;
                                                                        <span>{document.node.pictureType} <small>({document.node.description})</small></span>
                                                                    </p>
                                                                    <p><i className="fa fa-arrows-alt"></i></p>
                                                                </div>
                                                                <div className="DocumentCardPreview">
                                                                    {document.node ? (
                                                                        <img className="DocumentCardPreviewEmbed DocViewerImage" src={document.node.pictureUrl} alt="Document" />
                                                                    ) : ''}
                                                                </div>
                                                            </Card>
                                                        )}
                                                    </div>
                                                </Fragment>
                                            </Col>
                                        </Row>
                                    </div> :
                                    <div className="info-container" style={{ maxHeight: "500px", overflow: "auto" }}>
                                        <Row>
                                            <Col>
                                                <Fragment>
                                                    <div className="DocumentCardContainer">
                                                        {this.state.inspectionReportLoading && <Loader />}
                                                        {!this.state.inspectionReportLoading && this.state.inspectionReportError &&
                                                            <p className="text-center">{this.state.inspectionReportError}</p>}
                                                        {!this.state.inspectionReportLoading && !this.state.inspectionReportError && this.state.inspectionReportFor && !this.state.inspectionReportUrl &&
                                                            <p className="text-center">No inspection report for this inspection.</p>}
                                                        {this.state.inspectionReportUrl &&
                                                            <Card className="DocumentCard" key={`report-${this.props.carCondition.pk}`}>
                                                                {this.state.openModal === "viewInspectionReport" &&
                                                                    <ViewPDFDocument docUrl={this.state.inspectionReportUrl || ""} open={this.state.openModal === "viewInspectionReport"} handleClose={() => this.toggleModal("")} title="Inspection Report" />
                                                                }
                                                                <div className="DocumentCardHeader" onClick={() => this.toggleModal("viewInspectionReport")}>
                                                                    <p className="DocumentCardTitle">
                                                                        <span><i className="fa fa-picture-o" aria-hidden="true"></i></span>&nbsp;&nbsp;
                                                                        <span>Inspection Report <small>Inspection PDF Report</small></span>
                                                                    </p>
                                                                    <p><i className="fa fa-arrows-alt"></i></p>
                                                                </div>
                                                                <div className="DocumentCardPreview">
                                                                    <iframe scrolling="no" title="Inspection Report" className="DocumentCardPreviewEmbed DocViewerImage" src={this.state.inspectionReportUrl} />
                                                                </div>
                                                            </Card>
                                                        }
                                                    </div>
                                                </Fragment>
                                            </Col>
                                        </Row>
                                    </div>
                        }
                    </div>
                </>}
            </>
        )
    }
}

export default graphql(CarConditionDetailQuery, {
    options: ({ id, viewType }) => ({
        variables: {
            id,
            loadIncidentSet: viewType === "incidents" ? false : true
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    }),
    props: ({ data: { carCondition, loading, refetch, variables } }) => ({
        carCondition,
        carConditionLoading: loading,
        variables,
        refetchQuery: () => {
            return refetch({
                query: CarConditionDetailQuery,
                variables: {
                    ...variables,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { carCondition: fetchMoreResult.carCondition }
                },
            })
        },
    }),
})(
    graphql(CarIssuesSeverityLevelQuery, {
        props: ({ data: { carIssueSeverityLevels, loading } }) => ({
            carIssueSeverityLevels,
            loading,
        }),
    })(withApolloClient(CarInspectionDetail))
);


